export const TITLE = "activation.homepage.widget.competitors_traffic_share.title";
export const TOOLTIP = "activation.homepage.widget.competitors_traffic_share.tooltip";

export const FOOTER_EMPTY_PROJECT = "activation.homepage.widget.competitors_traffic_share.empty.create.project";
export const FOOTER_EMPTY_TOPIC = "activation.homepage.widget.competitors_traffic_share.empty.create.topic";
export const SHARED_TOPIC_CREATION_TOOLTIP =
    "activation.homepage.widget.competitors_traffic_share.shared.creation.tooltip";
